function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { tokens } from '@domain-group/fe-brary';
import { Checkbox } from '@domain-group/fe-co-form-elements';
import { ChevronUpIcon } from '@domain-group/fe-co-icon';
import WMSMapLayerLegend from '@domain-group/fe-allhomes-library/lib/enums/wms-map-layer-legend';
import WMSMapLayer from '@domain-group/fe-allhomes-library/lib/enums/wms-map-layer';
import { TabBar } from '@domain-group/fe-co-allhomes-tabbed-panel';
import LandDetailsPanel from './land-details-panel';
import AdvancedOption, { SCHOOL_LAYER_DEFAULT } from '../enums/advanced-option';
import * as styles from './overlay-popup.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var OFF_POSITION_PIXELS = 80;
var HEADING_HEIGHT = 76;
export var POSITIONS = {
  OFF: "".concat(OFF_POSITION_PIXELS, "px"),
  FIFTY: '50vh',
  OPEN: '100%'
};
var OverlayPopup = props => {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var panel = useRef();
  var pos = useRef(POSITIONS.OFF);
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    popupContainerHeight = _useState4[0],
    setPopupContainerHeight = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    enabledOverlay = _useState6[0],
    setEnabledOverlay = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    legend = _useState8[0],
    setLegend = _useState8[1];
  var draggingEnabled = useRef(false);
  var draggingPosition = useRef({});
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    tabIndex = _useState10[0],
    setTabIndex = _useState10[1];
  var updatePosition = useCallback(newPosition => {
    pos.current = newPosition;
    var newHeight = 0;
    if (typeof window !== 'undefined') {
      switch (newPosition) {
        case POSITIONS.FIFTY:
          newHeight = window.innerHeight / 2 - HEADING_HEIGHT;
          break;
        case POSITIONS.OPEN:
          newHeight = window.innerHeight - HEADING_HEIGHT;
          break;
        case POSITIONS.OFF:
        default:
          break;
      }
      setPopupContainerHeight("".concat(newHeight, "px"));
    }
    props.onNewPosition(newPosition);
  }, [props, setPopupContainerHeight]);
  var startDrag = useCallback(evt => {
    draggingEnabled.current = true;
    draggingPosition.current.start = evt.changedTouches[0].clientY;
  }, [draggingPosition, draggingEnabled]);
  var endDrag = useCallback(evt => {
    if (draggingEnabled.current) {
      draggingEnabled.current = false;
      draggingPosition.current.end = evt.changedTouches[0].clientY;
      var delta = draggingPosition.current.start - draggingPosition.current.end;
      if (delta < 0) {
        // downwards
        if (pos.current === POSITIONS.OPEN) {
          updatePosition(POSITIONS.FIFTY);
        } else {
          updatePosition(POSITIONS.OFF);
        }
      } else if (pos.current === POSITIONS.FIFTY) {
        updatePosition(POSITIONS.OPEN);
      } else {
        updatePosition(POSITIONS.FIFTY);
      }
    }
  }, [draggingPosition, draggingEnabled, pos, updatePosition]);
  var dragHandlers = {
    onTouchStart: startDrag,
    onTouchEnd: endDrag
  };

  // This side effect disables the touch move of any kind
  useEffect(() => {
    var htmlselector = null;
    if (typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden';
      htmlselector = document.querySelector('html');
      htmlselector.style.overflow = 'hidden';
    }
    return () => {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = 'auto';
        htmlselector.style.overflow = 'auto';
      }
    };
  }, []);
  var toggleOverlay = isOn => {
    setIsOpen(isOn);
    props.onOverlayToggle(isOn);
    if (!isOn) {
      setEnabledOverlay(null);
      setLegend(null);
      setTabIndex(0);
    }
  };
  var changeOverlay = layerKey => {
    var isSchool = layerKey === SCHOOL_LAYER_DEFAULT;
    toggleOverlay(layerKey !== null);
    setEnabledOverlay(WMSMapLayer[layerKey]);
    setLegend(WMSMapLayerLegend[layerKey]);
    props.onOverlaySelect(layerKey, isSchool);
    if (panel.current) {
      panel.current.scrollTop = 0;
    }
  };
  var tabs = AdvancedOption.map(option => ({
    id: option.key,
    label: option.title.toUpperCase()
  }));
  var handleTabClick = index => {
    setTabIndex(index);
    changeOverlay(tabs[index].id);
  };
  return ___EmotionJSX("div", {
    css: styles.container(pos.current)
  }, ___EmotionJSX("div", null, ___EmotionJSX("div", _extends({
    css: styles.sliderToggleContainer
  }, dragHandlers), ___EmotionJSX("span", {
    css: styles.sliderToggle
  })), ___EmotionJSX("div", {
    css: styles.headingContainer
  }, ___EmotionJSX("div", _extends({
    css: styles.headingText
  }, dragHandlers), pos.current === POSITIONS.OFF ? ___EmotionJSX("span", null, ___EmotionJSX(ChevronUpIcon, null), ___EmotionJSX("span", {
    css: styles.showOverlaysLabel
  }, "Show Overlays")) : ___EmotionJSX("span", null, "Overlays")), ___EmotionJSX("div", {
    css: styles.toggleContainer(isOpen)
  }, ___EmotionJSX(Checkbox, {
    name: "overlayToggle",
    type: "toggle",
    labelContent: "",
    checked: isOpen,
    onChange: () => {
      if (!isOpen && pos.current === POSITIONS.OFF) {
        // if we are enabling overlay with position off
        // show it at 50%
        updatePosition(POSITIONS.FIFTY);
      }
      if (!isOpen) {
        changeOverlay(WMSMapLayer.TP_ZONES.id);
      }
      toggleOverlay(!isOpen);
    }
  })))), ___EmotionJSX("div", {
    css: styles.innerContainer
  }, pos.current !== POSITIONS.OFF && ___EmotionJSX(Fragment, null, enabledOverlay && ___EmotionJSX(TabBar, {
    tabWrapper: ___EmotionJSX("div", {
      css: styles.tabWrapper
    }),
    activeIndex: tabIndex,
    tabs: tabs,
    onClick: handleTabClick,
    tabColour: tokens.colors.neutral.heavy.default,
    tabInactiveColour: tokens.colors.neutral.base.default
  }), ___EmotionJSX("div", {
    ref: panel,
    css: styles.panelBody(popupContainerHeight)
  }, ___EmotionJSX(LandDetailsPanel, {
    enabledOverlay: enabledOverlay,
    legend: legend,
    onUpdateOverlay: layerKey => changeOverlay(layerKey),
    onUpdateSchool: layerKey => changeOverlay(layerKey, true)
  })))));
};
OverlayPopup.propTypes = {
  onOverlayToggle: PropTypes.func.isRequired,
  onOverlaySelect: PropTypes.func.isRequired,
  onNewPosition: PropTypes.func
};
OverlayPopup.defaultProps = {
  onNewPosition: () => {}
};
export default OverlayPopup;